var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Move") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Move---Updated",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(7.018858, 7.000000)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-left",
    transform: "translate(4.402174, 9.085841) scale(-1, -1) rotate(-270.000000) translate(-4.402174, -9.085841) translate(1.528503, 4.683667)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2.87367062,
    y1: 1.72505653e-13,
    x2: 2.87367062,
    y2: 8.80434783,
    id: "fb6a91cd-0bad-4e11-9667-05009fa783e6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "71bfa851-2646-42f3-91b4-493ccf6daf20",
    points: "5.74734124 2.64130435 2.87367062 0 0 2.64130435"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-up",
    transform: "translate(5.968291, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "71bfa851-2646-42f3-91b4-493ccf6daf20",
    points: "5.74734124 2.64130435 2.87367062 0 0 2.64130435"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.88634858,
    y1: 0,
    x2: 2.87367062,
    y2: 8.80434783,
    id: "fb6a91cd-0bad-4e11-9667-05009fa783e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-left-copy",
    transform: "translate(13.560110, 9.085841) scale(-1, 1) rotate(-90.000000) translate(-13.560110, -9.085841) translate(10.686440, 4.683667)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2.87367062,
    y1: 1.72505653e-13,
    x2: 2.87367062,
    y2: 8.80434783,
    id: "fb6a91cd-0bad-4e11-9667-05009fa783e6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "71bfa851-2646-42f3-91b4-493ccf6daf20",
    points: "5.74734124 2.64130435 2.87367062 0 0 2.64130435"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-up-copy",
    transform: "translate(8.841962, 13.597826) scale(-1, 1) rotate(-180.000000) translate(-8.841962, -13.597826) translate(5.968291, 9.195652)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "71bfa851-2646-42f3-91b4-493ccf6daf20",
    points: "5.74734124 2.64130435 2.87367062 0 0 2.64130435"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.88634858,
    y1: 0,
    x2: 2.87367062,
    y2: 8.80434783,
    id: "fb6a91cd-0bad-4e11-9667-05009fa783e6"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.d69552e091fb7b94428330afe21cfcd2.svg";
export { ForwardRef as ReactComponent };